import React from "react";

export const LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_identity-bridge-17/artifacts/ckulix6j_ASAP_Roadside_Roadrunner_Rescue_AppIcon_Compressed.png";

export default function Logo({ size = 64, showText = true, dark = false, compact = false }) {
  const textSize = compact ? "text-lg" : "text-xl sm:text-2xl";
  const subSize = compact ? "text-[9px]" : "text-[10px]";
  return (
    <div className="flex items-center gap-3 min-w-0" data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="ASAP Roadside - Roadrunner Rescue"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        className="drop-shadow shrink-0"
      />
      {showText && (
        <div className="leading-none hidden md:block shrink-0">
          <div className={`font-display tracking-tight whitespace-nowrap ${textSize} ${dark ? "text-white" : "text-asap-deep"}`}>ASAP ROADSIDE</div>
          <div className={`${subSize} tracking-[0.28em] text-asap-orange font-bold mt-1.5 whitespace-nowrap`}>ROADRUNNER RESCUE</div>
        </div>
      )}
    </div>
  );
}
